<section class="grid gap-4">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <page-title [title]="'Client management'"></page-title>
    </div>

    <div class="flex items-center gap-3">
      @if (canManageCompanies()) {
        <!-- <a mat-stroked-button routerLink="/companies">Manage companies</a> -->
        <button matButton="filled" type="button" (click)="utils.navigateTo('/companies')">
          <mat-icon>manage_accounts</mat-icon>
          Manage companies
        </button>
      }

      @if (canCreate()) {
        <!-- <a mat-raised-button color="primary" routerLink="/clients/new">
          Create client
        </a> -->
        <button matButton="filled" type="button" class="mom-danger" (click)="utils.navigateTo('/clients/new')">
          <mat-icon>person_add</mat-icon>
          Create client
        </button>
      }
    </div>
  </div>

  <client-table
    [clients]="clientStore.clients()"
    [loading]="clientStore.loading()"
    [canDeactivate]="canDelete()"
    [canActivate]="canUpdate()"
    [actionClientId]="actionClientId()"
    (toggled)="toggleClientActive($event)" />
</section>